<template>
	<div>
		<div class="mb-2">
			Прозрачность слоя: {{ opacity }}
		</div>
		<b-form-input
			:disabled="!isSelected"
			v-model="opacity"
			type="range"
			min="0"
			max="1"
			step="0.05"
			@input="updateOpacity"
		></b-form-input>
	</div>
</template>

<script>
export default {
	props: ["canvas","value", "isSelected"],
	data() {
		return {
			opacity: this.value,
		};
	},
	methods: {
		updateOpacity() {
			this.canvas.getActiveObject().set("opacity", this.opacity);
			this.canvas.requestRenderAll();
		},
	},
};
</script>

<style></style>
